import { faqText } from "../../locales/en";

export const faqs = [
  {
    id: faqText.faqAccordian1.id,
    question: faqText.faqAccordian1.question,
    answer: faqText.faqAccordian1.answer
  },
  {
    id: faqText.faqAccordian2.id,
    question: faqText.faqAccordian2.question,
    answer: faqText.faqAccordian2.answer
  },
  {
    id: faqText.faqAccordian3.id,
    question: faqText.faqAccordian3.question,
    answer: faqText.faqAccordian3.answer
  },
  {
    id: faqText.faqAccordian4.id,
    question: faqText.faqAccordian4.question,
    answer: `${faqText.faqAccordian4.answer} 
<a href="mailto:${faqText.faqAccordian4.email}" class="faq-email-highlight">
  ${faqText.faqAccordian4.email}
</a> 
${faqText.faqAccordian4.text}`
  },
  {
    id: faqText.faqAccordian41.id,
    question: faqText.faqAccordian41.question,
    answer: faqText.faqAccordian41.answer
  },
  {
    id: faqText.faqAccordian5.id,
    question: faqText.faqAccordian5.question,
    answer: faqText.faqAccordian5.answer
  },
  {
    id: faqText.faqAccordian6.id,
    question: faqText.faqAccordian6.question,
    answer: `${faqText.faqAccordian6.answer} 
    <a href="mailto:${faqText.faqAccordian4.email}" class="faq-email-highlight">
  ${faqText.faqAccordian4.email}
</a> 
    
    ${faqText.faqAccordian6.text} </br> ${faqText.faqAccordian6.subText}`
  },
  {
    id: faqText.faqAccordian7.id,
    question: faqText.faqAccordian7.question,
    answer: faqText.faqAccordian7.answer
  },
  {
    id: faqText.faqAccordian8.id,
    question: faqText.faqAccordian8.question,
    answer: faqText.faqAccordian8.answer
  },
  {
    id: faqText.faqAccordian9.id,
    question: faqText.faqAccordian9.question,
    answer: faqText.faqAccordian9.answer
  },
  {
    id: faqText.faqAccordian10.id,
    question: faqText.faqAccordian10.question,
    answer: faqText.faqAccordian10.answer
  },
  {
    id: faqText.faqAccordian11.id,
    question: faqText.faqAccordian11.question,
    answer: faqText.faqAccordian11.answer
  },
  {
    id: faqText.faqAccordian12.id,
    question: faqText.faqAccordian12.question,
    answer: `${faqText.faqAccordian12.answer} <ul class="list-view" >
    <li>Invoice number</li>
    <li>The name of your debtor</li>
    <li>Invoice amount</li>
    <li>Date created</li>
    <li>Due date</li>
  </ul>
  `
  },
  {
    id: faqText.faqAccordian13.id,
    question: faqText.faqAccordian13.question,
    answer: faqText.faqAccordian13.answer
  }
];
